import { useState, useEffect } from "react";
import styles from "./CookieConsent.module.css"; // Создайте соответствующие стили

const CookieConsent = ({ onAccept }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Проверяем, не давал ли пользователь уже согласие
    const consentGiven = localStorage.getItem("cookieConsent") === "true";
    if (!consentGiven) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setVisible(false);
    onAccept();
  };

  if (!visible) return null;

  return (
    <div className={styles.bannerButton}>
      <div className={styles.banner}>
         <p>
          Мы используем cookies для авторизации и улучшения вашего опыта.
          Продолжая использовать сайт, вы соглашаетесь с этим. Более подробную информацию можно найти в  <a
            href={"/documents/cookiePolicy.pdf"}
            target="_blank"
            rel="noopener noreferrer"
          >Политике cookie файлов. </a>
        </p>
        <button onClick={handleAccept}>Принять</button>
      </div>
    </div>
  );
};

export default CookieConsent;